<template>
  <a-modal-wrapper
    :modal-name="MODAL.NEWSLETTER_FORM"
    close-button
    :width="568"
    class="news-letter-modal"
  >
    <a-newsletter-form
      :focus-on-mount="true"
      :form-id="$options.consts.FORM_ID.NEWSLETTER_MODAL"
      :close-on-submit="closeModal"
      class="news-letter-modal__form"
    />
  </a-modal-wrapper>
</template>

<script>
import AModalWrapper, { MODAL } from 'modals/AModalWrapper'
import { FORM_ID } from 'enums/form-id'
import { hydrateWhenVisible } from '@/utils/helpers/vue-lazy-hydration/LazyHydrate'

export default {
  name: 'ANewsLetterModal',
  components: {
    AModalWrapper,
    ANewsletterForm: hydrateWhenVisible(
      () => import('shared/ANewsletterForm'),
      { props: ['form-id', 'focus-on-mount', 'close-on-submit'] }
    )
  },
  consts: {
    FORM_ID
  },
  data() {
    return {
      MODAL
    }
  },
  methods: {
    closeModal() {
      this.$helper.closeModal(MODAL.NEWSLETTER_FORM)
    }
  }
}
</script>

<style lang="scss">
.news-letter-modal {
  &__form {
    position: relative;
    padding: 50px 30px 25px 25px;

    @include mobile {
      padding: 50px 10px 15px;
    }
  }
}

.modal-wrapper__overlay.news-letter-modal {
  z-index: 99999;
}
</style>
